import React from "react";

function Icon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit="2"
      clipRule="evenodd"
      viewBox="0 0 263 263"
      height={props.height? props.height : "20px"}
    >
      <path
        className={props.pathClass ? props.pathClass : "g1-fill"}
        d="M15753.3 2466.68c5.8-5.86 5.8-15.36 0-21.22l-72.1-72.09c-5.9-5.86-15.4-5.86-21.2 0l-154 154c-2.5 2.45-4 5.67-4.3 9.11l-7.9 78.98c-.5 4.44 1.1 8.85 4.2 12.03 3.2 3.17 7.5 4.79 12 4.41l80-6.89c3.5-.3 6.8-1.84 9.3-4.34l154-153.99zm-244.6 150.27l66.1-5.69-59.5-60.84-6.6 66.53zm11.7-82.8l71.3 72.9 151-150.98-72.1-72.1-150.2 150.18z"
        transform="matrix(.9963 0 0 .9963 -15436.3 -2360.19)"
      ></path>
    </svg>
  );
}

export default Icon;